<section class="error-area">
    <div class="error-item">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="error-text">
                    <h1>404!</h1>
                    <p>Lo sentimos! La página no existe <i class='bx bxs-sad bx-flip-horizontal bx-tada'></i></p>
                    <span>Oops! La página a la que intentas acceder no existe o ha sido eliminada.</span>
                    <a routerLink="/">Return to Home</a>
                </div>
            </div>
        </div>
    </div>
</section>